import styles from './SettingsHeader.module.scss';

import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { PATH } from '@app/index';

import { ArrowButtonIcon } from '@assets/icons';
import { Typography } from '@shared/Typography';
import { useTelegramBackButton } from '@utils/hooks/useTelegramBackButton';
import { isMobile } from '@utils/isMobile';
import { RawButton } from '@shared/RawButton';
import { useTranslation } from 'react-i18next';

export const SettingsHeader = () => {
  const nav = useNavigate();

  const { t } = useTranslation('mainPage');

  const tg = window?.Telegram?.WebApp ? window.Telegram.WebApp : undefined;

  const isTelegram = Boolean(tg);
  const isExpanded = tg?.isExpanded ?? false;

  const showTelegramBackButton = isTelegram && isExpanded && isMobile();
  const showArrowButton = !showTelegramBackButton;

  const goBack = useCallback(() => {
    nav(PATH.ACCOUNT);
  }, [nav]);

  // Показываем системную кнопку «назад» только если в Telegram на мобтльном устройсте и в полноэкранном режиме
  useTelegramBackButton(showTelegramBackButton, goBack);
  return (
    <div className={styles.chSettings}>
      {showArrowButton && (
        <RawButton onClick={goBack} className={styles.chBackButton}>
          <ArrowButtonIcon direction="left" width={20} height={20} />
        </RawButton>
      )}

      <Typography component="h1" variant="primary" textTransform="uppercase">
        {t('settings.title')}
      </Typography>
      <div />
    </div>
  );
};
